<template>
    <div class="layout-same-select-pop">
        <div class="share-sspp-title">你的八字库存在四柱相同的八字哦；如果是你朋友，赶紧告诉他吧！</div>
        <div class="share-sspp-list">
            <div class="share-sspp-item-high dsp-flex" v-for="itemData in selectedList" v-bind:key="itemData.id">
                <div class="share-sspp-item-content">
                    <p class="share-sspp-item-name">{{itemData.f_name}}({{itemData.sex == 0 ? '男' : '女'}})</p>
                    <p class="share-sspp-item-sub-note">
                        <span class="green">八字相同</span>
                        <span v-bind:class="{'green' : itemData.info && !!itemData.info.birthday, 'gray' : itemData.info && !itemData.info.birthday}">年份{{itemData.info.birthday ? '相同' : '不同'}}</span>
                        <span v-bind:class="{'green' : itemData.info && !!itemData.info.sex, 'gray' : itemData.info && !itemData.info.sex}">性别{{itemData.info.sex ? '相同' : '不同'}}</span>
                        <span v-bind:class="{'green' : itemData.info && !!itemData.info.name, 'gray' : itemData.info && !itemData.info.name}">名字{{itemData.info.name ? '相同' : '不同'}}</span>
                    </p>
                </div>
                <div class="share-sspp-item-button">
                    <button v-if="itemData.type == 'share'" class="share-sspp-btn share-sspp-tell-btn" @click.stop="clickTell(itemData)"><span>去告诉他</span></button>
                    <button v-if="itemData.type == 'like'" class="share-sspp-btn share-sspp-relate-btn" @click.stop="clickRelate(itemData)"><span>关联百科</span></button>
                </div>
            </div>
        </div>
        <div class="share-cgpp-button" @click="saveToNew">保存为新八字</div>
    </div>
</template>

<script>
export default {
    name: 'FamousBaikeSelectPop',
    props: {
        selectedList: {
            type: Array,
            default() {
                return []
            }
        },
        saveFunc: {
            type: Function,
            default() {
                return function() {}
            }
        },
        tellFunc: {
            type: Function,
            default() {
                return function() {}
            }
        },
        relateFunc: {
            type: Function,
            default() {
                return function() {}
            }
        },
    },
    methods: {
        clickTell(data) {
            if(this.tellFunc && typeof(this.tellFunc) == 'function') {
                this.tellFunc(data);
            }
        },
        clickRelate(data) {
            if(this.relateFunc && typeof(this.relateFunc) == 'function') {
                this.relateFunc(data);
            }
        },
        saveToNew() {
            if(this.saveFunc && typeof(this.saveFunc) == 'function') {
                this.saveFunc();
            }
        }
    }
}
</script>